import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoRailwayTag } from '../../../../state/tags/definitions/geo/railway';
import { TagNew } from '../../TagNew';

import { tagThemeSmall } from '../../tag_theme';

export interface IGeoRailwayTagItemProps {
  tag: IGeoRailwayTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const RailwayTagItem = (props: IGeoRailwayTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
